import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, Transition as _Transition, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ade7e34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-bar-sides" }
const _hoisted_2 = { class: "flex-auto" }
const _hoisted_3 = {
  key: 0,
  class: "flex justify-center items-center flex-1"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "top-bar-sides justify-end" }

import { computed, Ref, ref, watch } from 'vue';
import { isReadable } from '@ctrl/tinycolor';
import pageStore from '@/shared/content/page.store';
import siteContextStore from '@/shared/content/site-context.store';
import { PromotionBannerModel } from '@/types/B2BcontentServerContract';
import breakpointsState from '@/core/responsive/breakpoints/breakpoints-state.observable';
import useProfile from '@/shared/navigation/site-navigation/useProfile';
import CIcon from '@/shared/CIcon.vue';
import authStore from '@/shared/auth/auth.store';
import { useSessionStorage } from '@vueuse/core';
import Breakpoints from '@/core/responsive/breakpoints/Breakpoints.vue';
import CountryAndLanguageSelector from '@/shared/layout/page-header/top-bar/CountryAndLanguageSelector.vue';
import PartnerPrivateToggle from '@/shared/layout/page-header/top-bar/PartnerPrivateToggle.vue';
import Countdown from '@/shared/Countdown.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TopBar',
  props: {
    banner: null
  },
  setup(__props: any) {

const props = __props as {
    banner?: PromotionBannerModel | null;
}



const USER_DISMISSED_PROMOTION_BANNER = 'userDismissedPromotionBanner';
const userDismissedPromotionBanner: Ref<boolean> = useSessionStorage(USER_DISMISSED_PROMOTION_BANNER, false);

const topBarRef = ref<HTMLElement | null>(null);

watch(topBarRef, (topBarRef) => {
    if (topBarRef) {
        pageStore.setTopNavigationHeight(topBarRef.clientHeight);
    } else {
        pageStore.setTopNavigationHeight(0);
    }
});

const showTopBar = computed(() => {
    const isLargerScreens = breakpointsState.isBreakpointActive('min-lg');
    const isDismissed = isLargerScreens ? false : userDismissedPromotionBanner.value;
    const showPromoBanner = showPromotionBanner.value && !isDismissed;
    const topBarHasContent = showPromotionBanner.value || showSwitchLanguage.value || country.value.name || isSignedInAsPartner.value;

    return isLargerScreens ? topBarHasContent : showPromoBanner;
});

const dismissPromoBanner = () => {
    userDismissedPromotionBanner.value = true;
};

const { isSignedInAsPartner } = useProfile();

const showSwitchLanguage = computed(() => {
    return !authStore.isSignedInAsPartner && !authStore.isSignedInAsStore;
});

const country = computed(() => siteContextStore.getCountry());

const showPromotionBanner = computed(() => pageStore.hasActivePromotionBanner);
const showCountdown = computed(() => props.banner?.countDownCampaignModel?.countDownEnabled);
const activeIndex = ref<number>(0);
const isMultiContent = computed(() => props.banner && props.banner.content.length > 1);
const textColorIsReadable = computed(() => {
    let readable = true;
    if (props.banner?.backgroundColor && !isReadable('#fff', props.banner.backgroundColor)) {
        readable = false;
    }
    return readable;
});

const forward = () => {
    if (!props.banner) {
        return;
    }

    const oob = activeIndex.value + 1 === props.banner.content.length;
    activeIndex.value = oob ? 0 : activeIndex.value + 1;
};

const rewind = () => {
    if (!props.banner) {
        return;
    }

    const oob = activeIndex.value === 0;
    activeIndex.value = oob ? props.banner.content.length - 1 : activeIndex.value - 1;
};

return (_ctx: any,_cache: any) => {
  return (_unref(showTopBar))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref_key: "topBarRef",
        ref: topBarRef,
        class: _normalizeClass(["flex items-center justify-center lg:justify-between h-auto lg:h-56 py-x2 px-x3 xl:px-x8 bg-spring-green text-white overflow-hidden relative z-overlay lg:z-top-bar w-full", { 'text-black': !_unref(textColorIsReadable) }]),
        style: _normalizeStyle({ 'background-color': __props.banner?.backgroundColor })
      }, [
        _createVNode(Breakpoints, null, {
          "min-lg": _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              (!_unref(authStore).isSignedInAsStore)
                ? (_openBlock(), _createBlock(PartnerPrivateToggle, { key: 0 }))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_Transition, {
          name: "o-anim-fade-300",
          appear: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_unref(showPromotionBanner))
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    (!!_unref(showCountdown))
                      ? (_openBlock(), _createBlock(Countdown, {
                          key: "countdown",
                          class: "text-center o-rte-simple",
                          title: props.banner?.countDownCampaignModel.countdownTopTitle,
                          "title-bold": props.banner?.countDownCampaignModel.countdownTopTitleInBold,
                          "expired-text": props.banner?.countDownCampaignModel.expiredTitle,
                          timer: props.banner?.countDownCampaignModel.countDownTime || 0,
                          link: props.banner?.countDownCampaignModel.countdownLink,
                          "small-view": true
                        }, null, 8, ["title", "title-bold", "expired-text", "timer", "link"]))
                      : _createCommentVNode("", true),
                    (!_unref(showCountdown))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (_unref(isMultiContent))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: "rewind",
                                class: "p-5 mr-10 -mt-3",
                                onClick: rewind
                              }, [
                                _createVNode(CIcon, {
                                  name: "icon-arrow-small",
                                  class: "rotate-180 h-10"
                                })
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode(_Transition, {
                            name: "o-anim-fade-300",
                            mode: "out-in"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(), _createElementBlock("div", {
                                key: activeIndex.value,
                                class: "o-rte-simple text-center leading-14",
                                innerHTML: __props.banner?.content[activeIndex.value]
                              }, null, 8, _hoisted_4))
                            ]),
                            _: 1
                          }),
                          (_unref(isMultiContent))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: "forward",
                                class: "p-5 ml-10 -mt-3",
                                onClick: forward
                              }, [
                                _createVNode(CIcon, {
                                  name: "icon-arrow-small",
                                  class: "h-10"
                                })
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(Breakpoints, null, {
          "min-lg": _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(CountryAndLanguageSelector)
            ])
          ]),
          _: 1
        }),
        _createVNode(Breakpoints, null, {
          "max-sm": _withCtx(() => [
            _createElementVNode("button", {
              class: "ml-auto",
              "aria-label": "close",
              onClick: dismissPromoBanner
            }, [
              _createVNode(CIcon, {
                name: "icon-plus",
                "aria-hidden": "true",
                class: "rotate-45 h-12 w-12"
              })
            ])
          ]),
          _: 1
        })
      ], 6))
    : _createCommentVNode("", true)
}
}

})